import { Injectable } from '@angular/core'
import { MbProductDataImagesTabAdapter } from './mb-product-data-image-tab.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbProductDataImagesTabConnector {

  constructor (protected adapter: MbProductDataImagesTabAdapter) {
  }

  get (productCode: string, maxCount?: number) {
    return this.adapter.load(productCode, maxCount)
  }
}
